/**
 * @param oldFieldValue {string}
 * @param newFieldValue {string}
 * @return {boolean}
 */
module.exports = function didFieldValueUpdate(oldFieldValue, newFieldValue) {
    return oldFieldValue !== newFieldValue;
}